/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CbtStudentPaperSubmissionHistoryResponse } from '../models/CbtStudentPaperSubmissionHistoryResponse';
import type { GrantRetakeRequest } from '../models/GrantRetakeRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CbtPaperStudentRestControllerService {
  /**
   * grantRetake
   * @returns any OK
   * @throws ApiError
   */
  public static grantRetakeUsingPost({
    paperId,
    request,
  }: {
    /**
     * paperId
     */
    paperId: string;
    /**
     * request
     */
    request: GrantRetakeRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/cbt/papers/{paperId}/students/grant-retake',
      path: {
        paperId: paperId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSubmissionHistory
   * @returns CbtStudentPaperSubmissionHistoryResponse OK
   * @throws ApiError
   */
  public static getSubmissionHistoryUsingGet({
    paperId,
    studentId,
  }: {
    /**
     * paperId
     */
    paperId: string;
    /**
     * studentId
     */
    studentId: string;
  }): CancelablePromise<Array<CbtStudentPaperSubmissionHistoryResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cbt/papers/{paperId}/students/{studentId}/submission-history',
      path: {
        paperId: paperId,
        studentId: studentId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
